import type { SessionsListResult } from "../types.ts";
import { parseAgentSessionKey } from "../../../../src/routing/session-key.js";

export type FleetSessionBadge = {
  short: string;
  title: string;
};

function formatAgentId(agentId: string): string {
  return agentId.replace(/[^a-zA-Z0-9]+/g, "_").toUpperCase() || "MAIN";
}

function formatRestSuffix(rest: string): string | null {
  const lower = rest.toLowerCase();
  if (lower === "main") {
    return null;
  }
  if (lower.startsWith("fork:")) {
    return "fork";
  }
  if (lower.startsWith("subagent:")) {
    return "subagent";
  }
  if (lower.startsWith("session:")) {
    return "session";
  }
  if (rest.length <= 24) {
    return rest;
  }
  return `${rest.slice(0, 20)}…`;
}

export function resolveFleetSessionBadge(
  sessionKey: string,
  sessions?: SessionsListResult | null,
): FleetSessionBadge {
  const key = sessionKey.trim() || "main";
  const row = sessions?.sessions?.find((s) => s.key === key);
  const label = row?.label?.trim();
  const displayName = row?.displayName?.trim();

  const parsed = parseAgentSessionKey(key);
  let short: string;
  if (label) {
    short = label.length > 20 ? `${label.slice(0, 18)}…` : label;
  } else if (key === "main") {
    short = "MAIN";
  } else if (parsed) {
    const agentPart = formatAgentId(parsed.agentId);
    const suffix = formatRestSuffix(parsed.rest);
    short = suffix ? `${agentPart} · ${suffix}` : agentPart;
  } else {
    const head = key.split(":")[0]?.trim() || "main";
    short = formatAgentId(head);
  }

  const titleParts = [
    "Agent/session for this chat tab.",
    displayName && displayName !== short ? `Name: ${displayName}.` : "",
    `Key: ${key}`,
  ].filter(Boolean);

  return {
    short,
    title: titleParts.join(" "),
  };
}
